import { LandingHeader } from "./sections/LandingHeader";
import { HeroSection } from "./sections/HeroSection";
import { TrustBar } from "./sections/TrustBar";
import { PartnersSection } from "./sections/PartnersSection";
import { BuiltWithSection } from "./sections/BuiltWithSection";
import { NetworkSection } from "./sections/NetworkSection";
import { FeaturesSection } from "./sections/FeaturesSection";
import { MissionSection } from "./sections/MissionSection";
import { MetricSection } from "./sections/MetricSection";
import { OpenSourceSection } from "./sections/OpenSourceSection";
import { FinalCtaSection } from "./sections/FinalCtaSection";
import { LandingFooter } from "./sections/LandingFooter";
import { useTheme } from "@/providers/ThemeProvider";
import { useEffect, useRef } from "react";

export function HomeLandingPage() {
  const { theme, setTheme, colorTheme } = useTheme();
  const previousTheme = useRef(theme);

  useEffect(() => {
    if (theme !== "dark") {
      previousTheme.current = theme;
      setTheme("dark");
    }
    return () => {
      if (previousTheme.current !== "dark") {
        setTheme(previousTheme.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      data-marketing=""
      className={`dark min-h-screen overflow-x-hidden bg-background text-foreground theme-${colorTheme}`}
    >
      <LandingHeader />
      <main>
        <HeroSection />
        <TrustBar />
        <PartnersSection />
        <BuiltWithSection />
        <NetworkSection />
        <FeaturesSection />
        <MissionSection />
        <MetricSection />
        <OpenSourceSection />
        <FinalCtaSection />
      </main>
      <LandingFooter />
    </div>
  );
}
